import useVahakHttpClient from "hooks/useVahakHttpClient";
import { useVahakMutationQuery } from "hooks/useVahakQueryClient";

// constants
import API from "./const";
import { ApiErrorResponseType } from "custom-types/api-error-response-type";
import { QueryNames } from "./hooks/queryNames";

interface SendWhatsappOTPParams {
    phoneNumber: number | string;
}
interface SendWhatsappOTPResponse {
    data: { message: string };
}

export const useSendWhatsappOTP = () => {
    const { GET } = useVahakHttpClient();

    function sendWaOTP(params: SendWhatsappOTPParams) {
        const { phoneNumber } = params;
        return GET<SendWhatsappOTPResponse>(API.OTP_VIA_WHATSAPP + phoneNumber);
    }
    return useVahakMutationQuery<SendWhatsappOTPResponse, ApiErrorResponseType, SendWhatsappOTPParams>(
        [QueryNames.auth.sendWaOTP],
        sendWaOTP
    );
};
